<template lang="pug">
  #page.site
    oc-modal
    oc-header
    #content.site-content
      #primary.content-area
        main#main.site-main
          oc-hero
          oc-section1
          oc-section2
          oc-section3
          oc-section4
          oc-appointments
          oc-events
          oc-memberships
          oc-instructors
          oc-author
          oc-testimonials
    oc-footer
</template>

<script>
import OcFooter from '@/components/layout/Footer.vue'
import OcHeader from '@/components/layout/Header.vue'

import OcModal from '@/components/shared/Modal.vue'

import OcHero from '@/components/landing/Hero.vue'
import OcSection1 from '@/components/landing/Section1.vue'
import OcSection2 from '@/components/landing/Section2.vue'
import OcSection3 from '@/components/landing/Section3.vue'
import OcSection4 from '@/components/landing/Section4.vue'
import OcAppointments from '@/components/landing/Appointments.vue'
import OcEvents from '@/components/landing/Events.vue'
import OcMemberships from '@/components/landing/Memberships.vue'
import OcInstructors from '@/components/landing/Instructors.vue'
import OcAuthor from '@/components/landing/Author.vue'
import OcTestimonials from '@/components/landing/Testimonials.vue'

export default {
  name: 'app',
  components: {
    OcFooter,
    OcHeader,
    OcModal,
    OcHero,
    OcSection1,
    OcSection2,
    OcSection3,
    OcSection4,
    OcAppointments,
    OcEvents,
    OcMemberships,
    OcInstructors,
    OcAuthor,
    OcTestimonials
  }
}
</script>

<!-- Estilos cargados desde index.html -->



// WEBPACK FOOTER //
// src/App.vue